import React from 'react';

import styled from '@benzinga/themetron';
import { LoadingOutlined } from '@ant-design/icons';

const StyledLoadingIcon = styled(LoadingOutlined)`
  align-self: center;
  color: ${props => props.theme.colors.brand};
  flex: 1;
  font-size: 25px;
  justify-self: center;
  text-align: center;
`;

export interface Props {
  className?: string;
}

const Spinner: React.FunctionComponent<Props> = ({ className }) => <StyledLoadingIcon className={className} />;

export default Spinner;
